<template>
  <div class="dialog-batch-add-wrapper">
    <el-dialog title="批量添加设备" :visible="visible" @open="onDialogOpen" @close="onDialogClose">
      <el-form label-position="top" ref="batchBindForm" :rules="batchAddRules" :model="batchBindForm">

        <el-form-item
          label="入件商户"
          prop="userid"
          v-if="hasRes('user_index')" >
          <el-select v-model="batchBindForm.userid" filterable placeholder="请选择商户">
            <el-option
              v-for="user in userList"
              :key="user.userid"
              :label="user.username"
              :value="user.userid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="厂商"
          prop="factory_id"
          v-if="hasRes('factory_index') ">
          <el-select v-model="batchBindForm.factoryId" filterable placeholder="请选择设备所属厂商">
            <el-option
              v-for="(factory, index) in factoryList"
              :key="index"
              :label="factory.name"
              :value="factory.factory_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备 IMEI 号（有多个设备 IMEI 号时，一行一个 IMEI 号）" prop="clientids">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5 }"
            v-model="batchBindForm.clientids"></el-input>
        </el-form-item>

        <el-form-item label="设备名" prop="title">
          <el-input v-model="batchBindForm.title"></el-input>
        </el-form-item>

        <el-form-item label="通讯协议" prop="protocol">
          <el-radio v-model="batchBindForm.protocol" label="MQTT">MQTT</el-radio>
          <el-radio v-model="batchBindForm.protocol" label="SOCKET">Socket</el-radio>
        </el-form-item>

        <el-form-item label="通讯是否加密" prop="conn_encry">
          <el-radio v-model="batchBindForm.connEncry" :label="1">加密</el-radio>
          <el-radio v-model="batchBindForm.connEncry" :label="0">不加密</el-radio>
        </el-form-item>

        <el-form-item label="设备类型" prop="type">
          <el-select v-model="batchBindForm.type" placeholder="请选择设备类型" disabled>
            <el-option label="扭蛋机" value="gpm"></el-option>
            <el-option label="自动贩卖机" value="vm"></el-option>
            <el-option label="口红机" value="lpk"></el-option>
            <el-option label="脉冲" value="mc"></el-option>
            <el-option label="福袋机" value="fdj"></el-option>
            <el-option label="格子机" value="gzj"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备货架数量（个）" prop="goodsLength">
          <el-input-number
            v-model="batchBindForm.goodsLength"
            controls-position="right"
            :min="0"
            :max="100"
            disabled></el-input-number>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onBatchAddSubmit">确定</el-button>
          <el-button @click="onBatchAddCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'DialogBatchAdd',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    bindingAdvRegistries: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      batchBindForm: {
        userid: '',
        factoryId: 1808,
        clientids: '',
        type: 'vm',
        title: '自动贩卖机',
        platform: 'esy',
        protocol: 'MQTT',
        connEncry: 1,
        goodsLength: 0
      },
      batchAddRules: {
        userid: [
          { required: true, message: '请选择商户', 'trigger': 'blur' }
        ],
        clientids: [
          { required: true, message: '请输入设备 IMEI 号', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('user', [
      'userList'
    ]),
    ...mapState('factory', [
      'factoryList'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapActions('user', [
      'getUsers'
    ]),
    ...mapActions('factory', [
      'getFactories',
      'batchBindAdvRegistries'
    ]),

    onDialogOpen () {
      this.batchBindForm.type = this.bindingAdvRegistries[0].type
      this.batchBindForm.goodsLength = this.bindingAdvRegistries[0].goods_length
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    },
    onBatchAddSubmit () {
      this.$refs['batchBindForm'].validate(valid => {
        if (valid) {
          const sns = []
          for (let i in this.bindingAdvRegistries) {
            sns.push(this.bindingAdvRegistries[i].sn)
          }
          const clientids = this.batchBindForm.clientids.trim().split('\n')
          for (let item in clientids) {
            clientids[item] = clientids[item].trim()
          }

          // Check clientid count
          if (clientids.length > sns.length) {
            this.$message({
              type: 'error',
              message: '绑定失败，设备 imei 号过多'
            })
            return
          }

          const fullLoading = Loading.service({
            fullscreen: true
          })

          // 发送批量添加请求
          this.batchBindAdvRegistries({
            userid: this.batchBindForm.userid,
            sns,
            clientids,
            factoryId: this.batchBindForm.factoryId,
            title: this.batchBindForm.title,
            platform: 'esy',
            protocol: this.batchBindForm.protocol,
            connEncry: this.batchBindForm.connEncry
          }).then(res => {
            // 批量添加成功后，将成功添加的设备信息保存成文本文件给用户
            const result = []
            res.data.forEach(item => {
              result.push(`${item.clientid}, ${item.sn}, ${item.url}`)
            })

            const types = {
              'gpm': '扭蛋机',
              'vm': '自动贩卖机',
              'lpk': '口红机',
              'mc': '脉冲',
              'fdj': '福袋机',
              'gzj': '格子机'
            }

            // 创建隐藏的可下载链接
            let eleLink = document.createElement('a')
            eleLink.download = `${types[this.batchBindForm.type]}-${this.batchBindForm.title}-预生产设备批量绑定.txt`
            eleLink.style.display = 'none'

            // 字符内容转变成blob地址
            const blob = new Blob([result.join('\n')])
            eleLink.href = URL.createObjectURL(blob)
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)

            this.$nextTick(() => {
              fullLoading.close()
            })

            this.$refs['batchBindForm'].resetFields()
            this.$message({
              type: 'success',
              message: '批量绑定成功'
            })

            this.$emit('data-change')
            this.$emit('update:visible', false)
          }).catch(err => {
            console.log(err)

            this.$nextTick(() => {
              fullLoading.close()
            })
            this.$message({
              type: 'error',
              message: '批量绑定失败'
            })
          })
        } else {
          return false
        }
      })
    },
    onBatchAddCancel () {
      this.$emit('update:visible', false)
      this.$refs['batchBindForm'].resetFields()
    }
  },
  mounted () {
    if (this.hasRes('factory_index')) {
      this.getFactories({
        page: 1,
        pageSize: 9999
      })
    }
    if (this.hasRes('user_index')) {
      this.getUsers({
        page: 1,
        pageSize: 9999
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

</style>



// WEBPACK FOOTER //
// src/components/factory/DialogBatchBind.vue